import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import type { PendingAction } from './types';

export const TransitionConfirmDialog: React.FC<{
  pending: PendingAction;
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ pending, busy, onCancel, onConfirm }) => (
  <AlertDialog open={!!pending} onOpenChange={(o) => !o && onCancel()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>
          {pending ? `${pending.label[0].toUpperCase()}${pending.label.slice(1)} "${pending.name}"?` : ''}
        </AlertDialogTitle>
        <AlertDialogDescription>
          This moves the listing to <strong>{pending?.status}</strong>. Owners are notified of
          moderation changes. You can transition it again later.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <Button variant="outline" onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant={pending?.status === 'LIVE' ? 'default' : 'destructive'}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? 'Working…' : `Confirm ${pending?.label ?? ''}`}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
